import api from './api';
import { handleResponse, handleError } from './api';

/**
 * Co-host CRUD for an event. All endpoints require the caller to be the
 * event's primary host — the server enforces this; we just send the request.
 */
const coHostService = {
  async list(eventId) {
    try {
      return handleResponse(await api.get(`/events/${eventId}/co-hosts`));
    } catch (e) {
      return handleError(e);
    }
  },

  /**
   * Add a co-host with a revenue split.
   * @param {string} eventId
   * @param {{ userId: string, splitType: 'percent'|'fixed_cents', splitValueBasisPoints: number }} body
   *        For percent splits, basis points = pct × 100 (e.g. 25% → 2500).
   *        For fixed splits, basis points carry cents (e.g. $20 → 2000).
   */
  async add(eventId, body) {
    try {
      return handleResponse(await api.post(`/events/${eventId}/co-hosts`, body));
    } catch (e) {
      return handleError(e);
    }
  },

  async update(eventId, coHostId, body) {
    try {
      return handleResponse(await api.put(`/events/${eventId}/co-hosts/${coHostId}`, body));
    } catch (e) {
      return handleError(e);
    }
  },

  /** Primary host grants/revokes a co-host's permission to edit the event. */
  async setPermission(eventId, coHostId, canEdit) {
    try {
      return handleResponse(await api.put(`/events/${eventId}/co-hosts/${coHostId}/permissions`, { canEdit }));
    } catch (e) {
      return handleError(e);
    }
  },

  async remove(eventId, coHostId) {
    try {
      const response = await api.delete(`/events/${eventId}/co-hosts/${coHostId}`);
      return { success: response.status >= 200 && response.status < 300, data: null, error: null };
    } catch (e) {
      return handleError(e);
    }
  },
};

export default coHostService;
